import React, { useState, useRef, useEffect } from "react";
import OtpInputView from '../components/otp-input-view';
import PropTypes from "prop-types";

export const OtpInputContainer = ({
  onBlur,
  onComplete,
  error,
  resetKey,
}) => {
  const length = 6; // Default OTP length
  const [otp, setOtp] = useState(Array.from({ length: length }, () => ""));
  const inputRefs = useRef([]);

  useEffect(() => {
    if (resetKey !== undefined) {
      setOtp(Array.from({ length: length }, () => ""));
    }
  }, [resetKey, length]);

  const handleChange = (index, inputValue) => {

    const numericValue = inputValue.replace(/[^0-9]/g, "");

    if (numericValue.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = numericValue;
      setOtp(newOtp);
      const otpString = newOtp.join("");
      if (numericValue && index < length - 1 && inputRefs.current[index + 1]) {
        inputRefs.current[index + 1].focus();
      }
      if (otpString.length === length && onComplete) {
        onComplete(otpString);
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];
      if (otp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        newOtp[index - 1] = "";
        setOtp(newOtp);
        inputRefs.current[index - 1].focus();
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (e.key === "ArrowRight" && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    const numericText = pastedText.replace(/[^0-9]/g, "");

    if (numericText) {
      const newOtp = numericText.split("").slice(0, length);
      while (newOtp.length < length) {
        newOtp.push("");
      }
      setOtp(newOtp);
      const otpString = newOtp.join("").substring(0, length);

      const nextEmptyIndex = newOtp.findIndex(digit => !digit);
      const focusIndex = nextEmptyIndex !== -1 ? nextEmptyIndex : length - 1;
      if (inputRefs.current[focusIndex]) {
        inputRefs.current[focusIndex].focus();
      }

      if (otpString.length === length && onComplete) {
        onComplete(otpString);
      }
    }
  };

  const handleInputBlur = () => {
    if (onBlur) {
      onBlur(otp.join(""));
    }
  };

  return (
    <OtpInputView
      otp={otp}
      handleChange={handleChange}
      handleInputBlur={handleInputBlur}
      handleKeyDown={handleKeyDown}
      handlePaste={handlePaste}
      inputRefs={inputRefs}
      onBlur={onBlur}
      onComplete={onComplete}
      length={length}
      error={error}
    />
  );
};

OtpInputContainer.propTypes = {
  onBlur: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  resetKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default OtpInputContainer;
